import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  Events,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import { Order, OrderComponent } from "models/order-management/models";
import { OrderFormState } from "pages/orders-entry-om/add-order/order-form-state";
import { NavBarServiceProvider } from "providers/nav-bar-service/nav-bar-service";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";
import Toggle from "../../../models/toggle";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import {
  OrderComponentInterface,
  OrderComponentPropertyUpdate,
  OrderCreateRequestUpdate,
} from "../order-components-interface";

@Component({
  selector: "current-diagnosis",
  templateUrl: "current-diagnosis.html",
})
export class CurrentDiagnosisComponent implements OrderComponentInterface {
  /****************************************************************************
   * Inputs                                                                   *
   ****************************************************************************/
  @Input() orderComponent: OrderComponent;
  @Input() orderCreateRequest: Order;
  @Input() orderFormState: OrderFormState;

  /****************************************************************************
   * Outputs                                                                  *
   ****************************************************************************/
  @Output() orderCreateRequestEvent =
    new EventEmitter<OrderCreateRequestUpdate>();
  @Output() orderFormStateEvent = new EventEmitter<OrderFormState>();
  @Output() isValidEvent = new EventEmitter<boolean>();
  @Output() amendedOrderRequestEvent =
    new EventEmitter<OrderComponentPropertyUpdate>();

  /****************************************************************************
   * State                                                                    *
   ****************************************************************************/
  primaryDiagnosis: string;
  secondaryDiagnosis: string;
  relatedDiagnosis: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public stateData: StateManagementService,
    public navBarServiceProvider: NavBarServiceProvider,
    public referralService: ReferralsServiceProvider,
    public events: Events
  ) {}

  /****************************************************************************
   * Lifecycle Methods                                                        *
   ****************************************************************************/
  ngOnInit() {
    this.loadDiagnosisInfo();
  }

  /****************************************************************************
   * Component Related Methods                                                *
   ****************************************************************************/
  loadDiagnosisInfo() {
    let chartId = this.navBarServiceProvider.parsePatientChartIdsFromUrl(
      window.location.toString()
    );
    const patientChartId = chartId.patientChartId;
    const useExternalId = chartId.externalId;
    const isNewPatientChart = patientChartId > 199999 ? true : false;
    const toggle = new Toggle();
    this.referralService
      .getPatientChartBrief(
        patientChartId,
        useExternalId,
        isNewPatientChart,
        toggle
      )
      .subscribe((diagnosisInfo) => {
        if (diagnosisInfo) {
          this.primaryDiagnosis =
            diagnosisInfo.primaryDiagnosisDescription || "None";
          this.secondaryDiagnosis =
            diagnosisInfo.secondaryDiagnosisDescription || "None";
          this.relatedDiagnosis = "None";
        }
      });
  }

  /****************************************************************************
   * Cypress-Related ("data-cy") Methods                                      *
   ****************************************************************************/
  toKebabCase(label: string): string {
    if (label) {
      return label
        .replace(/^\s+|\s+$/gm, "")
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
    }
    return "";
  }

  createDataCyAttribute(component: string, option: string): string {
    return `${this.toKebabCase(component)}-option-${this.toKebabCase(option)}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/order-management/current-diagnosis/current-diagnosis.ts